import React, { Fragment } from 'react';
import BaseComponent, { connect } from '@common/components/base.component';
import { Col, Row } from 'react-bootstrap';
import Form from '@common/externos/components/validation/form.validation';
import DDadosItem from '@common/components/ddados/ddados.item';
import DDados from '../redeSIM.ddados';
import Recaptcha from 'react-recaptcha';
import autobind from 'react-autobind';
import Card from '@common/externos/components/card/card.externo';

class Container extends BaseComponent {
  constructor(props) {
    super(props);
    autobind(this);
  }

  onCancel() {
    const { routerManager } = this.props;
    routerManager.redirect({ name: 'RedeSIM' });
  }

  render() {
    const { Campos } = DDados;
    const { title, onSubmit, verifyCallback, expiredCallback, onSearch, isView, recaptchaRef } = this.props;

    return (
      <Card className={'pb-0'}>
        <h2 className={'mb-4'}>{title}</h2>
        <Form onSubmit={onSubmit} onCancel={this.onCancel} onSearch={onSearch} isView={isView}>
          {(form) => (
            <Fragment>
              <Row>
                <Col xs={12} lg={4}>
                  <DDadosItem name="NumeroProtocolo" {...Campos.NumeroProtocolo} />
                </Col>
                <Col xs={12} lg={4}>
                  <DDadosItem name="CpfCnpjSolicitante" {...Campos.CpfCnpjSolicitante} />
                </Col>
                <Col xs={12} lg={4}>
                  <DDadosItem name="CnpjEmpresa" {...Campos.CnpjEmpresa} />
                </Col>
              </Row>
              <div elementID="1">
                <Row>
                  <Col xs={12} lg={4}>
                    <Recaptcha
                      elementID="1"
                      ref={recaptchaRef}
                      sitekey={'6LeSHQETAAAAACjgu00LxcbscsmkkwMIqhfd1-Gh'}
                      verifyCallback={verifyCallback}
                      render={'explicit'}
                      expiredCallback={expiredCallback}
                      hl="pt-br"
                      theme="light"
                      size="normal"
                    />
                  </Col>
                </Row>
              </div>
            </Fragment>
          )}
        </Form>
      </Card>
    );
  }
}

export default connect()(Container);
